import { Component, OnInit } from '@angular/core';
import { Tienda } from '../tiendas/tienda';
import { TotemService } from '../totem.service';
import { PRICE_TAG_ORANGE } from '../assets-inline';

@Component({
  selector: 'app-ofertas',
  templateUrl: './ofertas.component.html',
  styleUrls: ['./ofertas.component.css']
})
export class OfertasComponent implements OnInit {
  tiendas: Array<Tienda>;
  ofertas: any = [];

  // Icono price-tag inlineado (base64) para evitar ERR_CONNECTION_REFUSED.
  public priceTagOrange = PRICE_TAG_ORANGE;

  

  constructor(private totemService: TotemService) { }


 

  ngOnInit() {
    this.obtenerTiendas();
  }

  async obtenerTiendas() {
    try {
      await this.totemService.obtenerTiendasOrdenadas('es').then((res: any) => {
        this.tiendas = res;
        this.obtenerOfertas();
      })
    } catch (err) {
      console.log(err);
      
    }
  }

 

  async obtenerOfertas() {
    try {
      const ofertasDisp = await this.totemService.geteventos('es').toPromise().then((res: any) => {
        return res.filter((evento: any) => evento.tipo_evento === 'Ofertas' && evento.descuento !== '0');
      });
      ofertasDisp.forEach(oferta => {
        const ofertaTienda = this.tiendas.find((tienda: Tienda) => tienda.puntoInteres === oferta.punto_interes);
        if (ofertaTienda) {
          oferta.tienda = ofertaTienda;
          oferta.nombre_tienda = ofertaTienda.nombre;
          this.ofertas.push(oferta)
        }
      });
      this.ofertas.sort((a, b) => a.tienda.nombre.localeCompare(b.tienda.nombre) )
      const ofertasAgrupadas = await this.groupBy('nombre_tienda' , this.ofertas);
      const ofertasAgrupadas2 = await this.unaOfertaPorTienda(ofertasAgrupadas);
      this.ofertas = ofertasAgrupadas2;
      console.log(ofertasAgrupadas2 , 'super saya face 3 ');
    } catch (err) {
      console.log(err);
    }
  };


  async groupBy (key , array)  {
      return array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {});
  }

  async unaOfertaPorTienda (arrayOfertas){
    const obj = arrayOfertas;
    const arrayRetorno  = [];
      Object.keys(obj).forEach(async key => {
        const primeraOferta =  await this.getFirtsEmentArray(obj[key]);
        arrayRetorno.push({nombre_tienda:key , primera_oferta :primeraOferta });
        //console.log("key: ", key);
          //console.log("Value: ", obj[key]);
      } );

      return arrayRetorno;
  }

  async getFirtsEmentArray (array) {
    for (let i in array) return array[i];
  }

  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }
}
